import sanityClient from "@sanity/client"

export default sanityClient({
    projectId: '8buxcg1p',
    dataset: 'production',
    token: '',
    useCdn: false
});